import { History } from "history";
import {
  NoPurchasesParentsReportDto,
  NoPurchasesStudentsReportDto,
} from "../../interfaces/reports";

//#region Get No Purchases Students Report

export const GET_NO_PURCHASES_STUDENTS_REPORT =
  "GET_NO_PURCHASES_STUDENTS_REPORT";
export const GET_NO_PURCHASES_STUDENTS_REPORT_SUCCESS: any =
  "GET_NO_PURCHASES_STUDENTS_REPORT_SUCCESS";
export const GET_NO_PURCHASES_STUDENTS_REPORT_ERROR: any =
  "GET_NO_PURCHASES_STUDENTS_REPORT_ERROR";

export const RESET_NO_PURCHASES_STUDENTS_REPORT: any =
  "RESET_NO_PURCHASES_STUDENTS_REPORT";

export interface GetNoPurchasesStudentsReportAction {
  type: typeof GET_NO_PURCHASES_STUDENTS_REPORT;
  payload: { history: History };
}

export interface GetNoPurchasesStudentsReportSuccessAction {
  type: typeof GET_NO_PURCHASES_STUDENTS_REPORT_SUCCESS;
  payload: NoPurchasesStudentsReportDto[];
}

export interface GetNoPurchasesStudentsReportErrorAction {
  type: typeof GET_NO_PURCHASES_STUDENTS_REPORT_ERROR;
  payload: any;
}

export interface ResetNoPurchasesStudentsReportAction {
  type: typeof RESET_NO_PURCHASES_STUDENTS_REPORT;
  payload: {};
}
//#endregion

//#region Get No Purchases Parents Report

export const GET_NO_PURCHASES_PARENTS_REPORT =
  "GET_NO_PURCHASES_PARENTS_REPORT";
export const GET_NO_PURCHASES_PARENTS_REPORT_SUCCESS: any =
  "GET_NO_PURCHASES_PARENTS_REPORT_SUCCESS";
export const GET_NO_PURCHASES_PARENTS_REPORT_ERROR: any =
  "GET_NO_PURCHASES_PARENTS_REPORT_ERROR";

export const RESET_NO_PURCHASES_PARENTS_REPORT: any =
  "RESET_NO_PURCHASES_PARENTS_REPORT";

export interface GetNoPurchasesParentsReportAction {
  type: typeof GET_NO_PURCHASES_PARENTS_REPORT;
  payload: { history: History };
}

export interface GetNoPurchasesParentsReportSuccessAction {
  type: typeof GET_NO_PURCHASES_PARENTS_REPORT_SUCCESS;
  payload: NoPurchasesParentsReportDto[];
}

export interface GetNoPurchasesParentsReportErrorAction {
  type: typeof GET_NO_PURCHASES_PARENTS_REPORT_ERROR;
  payload: any;
}

export interface ResetNoPurchasesParentsReportAction {
  type: typeof RESET_NO_PURCHASES_PARENTS_REPORT;
  payload: {};
}
//#endregion

//#region Get No Subscriptions Students Report

export const GET_NO_SUBSCRIPTION_STUDENTS_REPORT =
  "GET_NO_SUBSCRIPTION_STUDENTS_REPORT";
export const GET_NO_SUBSCRIPTION_STUDENTS_REPORT_SUCCESS: any =
  "GET_NO_SUBSCRIPTION_STUDENTS_REPORT_SUCCESS";
export const GET_NO_SUBSCRIPTION_STUDENTS_REPORT_ERROR: any =
  "GET_NO_SUBSCRIPTION_STUDENTS_REPORT_ERROR";

export const RESET_NO_SUBSCRIPTION_STUDENTS_REPORT: any =
  "RESET_NO_SUBSCRIPTION_STUDENTS_REPORT";

export interface GetNoSubscriptionStudentsReportAction {
  type: typeof GET_NO_SUBSCRIPTION_STUDENTS_REPORT;
  payload: { history: History };
}

export interface GetNoSubscriptionStudentsReportSuccessAction {
  type: typeof GET_NO_SUBSCRIPTION_STUDENTS_REPORT_SUCCESS;
  payload: NoPurchasesStudentsReportDto[];
}

export interface GetNoSubscriptionStudentsReportErrorAction {
  type: typeof GET_NO_SUBSCRIPTION_STUDENTS_REPORT_ERROR;
  payload: any;
}

export interface ResetNoSubscriptionStudentsReportAction {
  type: typeof RESET_NO_SUBSCRIPTION_STUDENTS_REPORT;
  payload: {};
}
//#endregion

//#region Get No Subscription Parents Report

export const GET_NO_SUBSCRIPTION_PARENTS_REPORT =
  "GET_NO_SUBSCRIPTION_PARENTS_REPORT";
export const GET_NO_SUBSCRIPTION_PARENTS_REPORT_SUCCESS: any =
  "GET_NO_SUBSCRIPTION_PARENTS_REPORT_SUCCESS";
export const GET_NO_SUBSCRIPTION_PARENTS_REPORT_ERROR: any =
  "GET_NO_SUBSCRIPTION_PARENTS_REPORT_ERROR";

export const RESET_NO_SUBSCRIPTION_PARENTS_REPORT: any =
  "RESET_NO_SUBSCRIPTION_PARENTS_REPORT";

export interface GetNoSubscriptionParentsReportAction {
  type: typeof GET_NO_SUBSCRIPTION_PARENTS_REPORT;
  payload: { history: History };
}

export interface GetNoSubscriptionParentsReportSuccessAction {
  type: typeof GET_NO_SUBSCRIPTION_PARENTS_REPORT_SUCCESS;
  payload: NoPurchasesParentsReportDto[];
}

export interface GetNoSubscriptionParentsReportErrorAction {
  type: typeof GET_NO_SUBSCRIPTION_PARENTS_REPORT_ERROR;
  payload: any;
}

export interface ResetNoSubscriptionParentsReportAction {
  type: typeof RESET_NO_SUBSCRIPTION_PARENTS_REPORT;
  payload: {};
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetNoPurchasesStudentsReportAction
  | GetNoPurchasesStudentsReportSuccessAction
  | GetNoPurchasesStudentsReportErrorAction
  | ResetNoPurchasesStudentsReportAction
  | GetNoPurchasesParentsReportAction
  | GetNoPurchasesParentsReportSuccessAction
  | GetNoPurchasesParentsReportSuccessAction
  | ResetNoPurchasesParentsReportAction
  | GetNoSubscriptionStudentsReportAction
  | GetNoSubscriptionStudentsReportSuccessAction
  | GetNoSubscriptionStudentsReportErrorAction
  | ResetNoSubscriptionStudentsReportAction
  | GetNoSubscriptionParentsReportAction
  | GetNoSubscriptionParentsReportSuccessAction
  | GetNoSubscriptionParentsReportSuccessAction
  | ResetNoSubscriptionParentsReportAction;
